import { render, staticRenderFns } from "./expertDetails.vue?vue&type=template&id=7a975e35&scoped=true"
import script from "./expertDetails.vue?vue&type=script&lang=js"
export * from "./expertDetails.vue?vue&type=script&lang=js"
import style0 from "./expertDetails.vue?vue&type=style&index=0&id=7a975e35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a975e35",
  null
  
)

export default component.exports